import { globalApi as api } from '../../api';

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});

export const loginUser = async (userData) => {
  try {
    const response = await api.post('/login', userData);
    const token = response.data.access_token;
    return {
      data: response.data,
      status: response.status,
      token: token,
    };
  } catch (error) {
    throw error.response ? error.response.data.message : error.message;
  }
};

export const verifyOtp = async (otpData) => {
  try {
    const response = await api.post('/verify_otp', otpData);
    const token = response.data.auth_token;
    if (token) {
      localStorage.setItem('token', token);
      sessionStorage.setItem('token', token);
    }
    return {
      data: response.data,
      status: response.status,
      token: token,
    };
  } catch (error) {
    throw error.response ? error.response.data.message : error.message;
  }
};

export const forgotPassword = async (userData) => {
  try {
    const response = await api.post('/forgot_password', userData);
    return {
      data: response.data,
      status: response.status
    };
  } catch (error) {
    throw error.response ? error.response.data : error.message;
  }
};

export const resetPassword = async (userData) => {
  try {
    const response = await api.post('/reset_password', userData);
    return {
      data: response.data,
      status: response.status
    };
  } catch (error) {
    throw error.response ? error.response.data : error.message;
  }
};

export const createUsers = async (AddUser) => {
  try {
    const token = sessionStorage.getItem('token');
    const response = await api.post('/register', AddUser, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    return {
      data: response.data,
      status: response.status,
    };
  } catch (error) {
    if (error.response) {
      return error.response.data
    } else {
      console.error("Error Message", error.message);
      throw new Error(error.message || 'An error occurred');
    }
  }
};

export const fetchUser = async (CompanyID) => {
  try {
    const token = sessionStorage.getItem('token');
    const response = await api.get(`/user/${CompanyID}`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data.error : error.message;
  }
};

export const updateUser = async (id, updateUserData) => {
  try {
    const token = sessionStorage.getItem('token');
    const response = await api.put(`/user/${id}`, updateUserData, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data.error : error.message;
  }
};

export const deleteUser = async (id) => {
  try {
    const token = sessionStorage.getItem('token');
    const response = await api.delete(`/user/${id}`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data.error : error.message;
  }
};

export const reSentOtp = async (resent) => {
  try {
    const response = await api.post('/resend_otp', resent);
    return {
      data: response.data,
      status: response.status,
    };
  } catch (error) {
    if (error.response) {
      return error.response.data
    } else {
      console.error("Error Message", error.message);
      throw new Error(error.message || 'An error occurred');
    }
  }
};
export const reSentMail = async (resentMail) => {
  try {
    const token = sessionStorage.getItem('token');
    const response = await api.post('/resend-email', resentMail, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    return {
      data: response.data,
      status: response.status,
    };
  } catch (error) {
    if (error.response) {
      return error.response.data
    } else {
      console.error("Error Message", error.message);
      throw new Error(error.message || 'An error occurred');
    }
  }
};
export const updateUserPassword = async (updateUserData) => {
    try {
      const token = sessionStorage.getItem('token');
      const response = await api.post(`/change_password`, updateUserData, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error) {
      throw error.response ? error.response.data.message : error.message;
    }
  };

export const uploadUserProfile = async (formData) => {
  try {
    const token = sessionStorage.getItem("token");
    const response = await api.post(`/upload_profile`, formData, {
      headers: {
        "Authorization": `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data.message : error.message;
  }
};

export const deleteUserProfile = async () => {
  try {
    const token = sessionStorage.getItem("token");
    const response = await api.delete(`/delete_profile`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data.message : error.message;
  }
};

export const fetchUsersProfiles = async () => {
  try { 
    const token = sessionStorage.getItem("token");
    const response = await api.get(`/get_profile`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data; // { profile: "path/to/image.jpg" }
  } catch (error) {
    return { profile: null }; // fallback to null
  }
};

export const fetchUserProfile = async () => {
  try {
    const token = sessionStorage.getItem("token");

    const userStr = sessionStorage.getItem("user");
    const user = userStr ? JSON.parse(userStr) : null;
    const userId = user?.user_id;

    if (!userId) {
      console.error("User ID not found in sessionStorage");
      return { profile: null };
    }

    const response = await api.get(`/user_profiles/${userId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  } catch (error) {
    console.error("Fetch user profile failed:", error);
    return { profile: null };
  }
};

